// extracted by mini-css-extract-plugin
module.exports = {"RequestEditBody":"_1q2w3x2PI3hXsIAwiRKGLV","RequestBoardBody":"_3IWHE60rLgriVFS7jxqX_Z","searchInput":"_3e6j8B8RVuR8Osk9IbC8kO"};